import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
};

/** Тип абонемента */
export enum AbonnementTypeEnum {
  /** Вдохновленный читатель */
  InspiredReader = 'inspired_reader',
  /** Заинтересованный читатель */
  InterestedReader = 'interested_reader',
  /** Легендарный читатель */
  LegendaryReader = 'legendary_reader'
}

/** Параметры запроса покупки абонемента */
export type BuyAbonnementInput = {
  /** Тип абонемента */
  abonnementType?: InputMaybe<AbonnementTypeEnum>;
  /** ID сохраненной банковской карты */
  bankCardId?: InputMaybe<Scalars['Int']['input']>;
  /** ID книги */
  bookId?: InputMaybe<Scalars['Int']['input']>;
  /** Email на который будет отправлен чек */
  emailForReceipt?: InputMaybe<Scalars['String']['input']>;
  /** Способ оплаты */
  paymentMethod?: InputMaybe<PaymentMethodEnum>;
  /** URL возврата пользователя после оплаты */
  returnUrl?: InputMaybe<Scalars['String']['input']>;
};

/** Результат запроса покупки абонемента */
export type BuyAbonnementPayload = {
  __typename?: 'BuyAbonnementPayload';
  /** Транзакция */
  transaction?: Maybe<TransactionGqt>;
};

/** Результат запроса покупки абонемента */
export type BuyAbonnementUnion = BuyAbonnementPayload | ProblemType;

/** Изображение */
export type Image = {
  __typename?: 'Image';
  /** Формат */
  format: Scalars['String']['output'];
  /** Тип размера изображения */
  sizeType: Scalars['String']['output'];
  /** URL */
  url: Scalars['String']['output'];
};

export type Mutation = {
  __typename?: 'Mutation';
  /** Купить абонемент */
  buyAbonnement?: Maybe<BuyAbonnementUnion>;
};


export type MutationBuyAbonnementArgs = {
  input?: InputMaybe<BuyAbonnementInput>;
};

/** Навигация по страницам */
export type PagerType = {
  __typename?: 'PagerType';
  /** Номер страницы */
  page: Scalars['Int']['output'];
  /** Количество элементов на странице */
  perPage: Scalars['Int']['output'];
  /** Общее количество элементов */
  total: Scalars['Int']['output'];
};

/** Способ оплаты */
export enum PaymentMethodEnum {
  /** Банковская карта */
  BankCard = 'bank_card',
  /** Сохраненная банковская карта */
  SavedBankCard = 'saved_bank_card'
}

/** Пользовательская ошибка */
export type ProblemType = {
  __typename?: 'ProblemType';
  /** Описание ошибки */
  message?: Maybe<Scalars['String']['output']>;
};

export type Query = {
  __typename?: 'Query';
  _empty?: Maybe<Scalars['String']['output']>;
};

/** Транзакция */
export type TransactionGqt = {
  __typename?: 'TransactionGQT';
  /** URL для подтверждения транзакции */
  confirmationUrl?: Maybe<Scalars['String']['output']>;
  /** Идентификатор транзакции */
  id: Scalars['Int']['output'];
};

/** Ошибка: требуется авторизация */
export type UnauthorizedProblemType = {
  __typename?: 'UnauthorizedProblemType';
  /** Описание ошибки */
  message?: Maybe<Scalars['String']['output']>;
};

export type BuyAbonnementMutationVariables = Exact<{
  input?: InputMaybe<BuyAbonnementInput>;
}>;


export type BuyAbonnementMutation = { __typename?: 'Mutation', buyAbonnement?: { __typename?: 'BuyAbonnementPayload', transaction?: { __typename?: 'TransactionGQT', id: number, confirmationUrl?: string | null } | null } | { __typename?: 'ProblemType', message?: string | null } | null };


export const BuyAbonnementDocument = gql`
    mutation buyAbonnement($input: BuyAbonnementInput) {
  buyAbonnement(input: $input) {
    ... on ProblemType {
      message
    }
    ... on BuyAbonnementPayload {
      transaction {
        id
        confirmationUrl
      }
    }
  }
}
    `;
export type BuyAbonnementMutationFn = Apollo.MutationFunction<BuyAbonnementMutation, BuyAbonnementMutationVariables>;

/**
 * __useBuyAbonnementMutation__
 *
 * To run a mutation, you first call `useBuyAbonnementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBuyAbonnementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [buyAbonnementMutation, { data, loading, error }] = useBuyAbonnementMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBuyAbonnementMutation(baseOptions?: Apollo.MutationHookOptions<BuyAbonnementMutation, BuyAbonnementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BuyAbonnementMutation, BuyAbonnementMutationVariables>(BuyAbonnementDocument, options);
      }
export type BuyAbonnementMutationHookResult = ReturnType<typeof useBuyAbonnementMutation>;
export type BuyAbonnementMutationResult = Apollo.MutationResult<BuyAbonnementMutation>;
export type BuyAbonnementMutationOptions = Apollo.BaseMutationOptions<BuyAbonnementMutation, BuyAbonnementMutationVariables>;